import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'

export const Route = createFileRoute('/_app/hr/employees')({
  staticData: { crumb: 'hrEmployees' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'employees.read'),
  component: Outlet,
})
